export default __webpack_public_path__ + "images/19898e9352090c750a662d5f37dae9da.png";